import styled from '@emotion/styled'
import {css} from '@emotion/react'
import {theme} from '../../theme'

// AccordionCard
// Outer shell — white card with border and subtle shadow.

export const AccordionCard = styled.div`
  background-color: ${({isOpen}) =>
    isOpen ? theme.palette.thryv.bg : '#ffffff'};
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
  // box-shadow: ${theme.shadows.sm};
  overflow: hidden;
  transition: box-shadow ${theme.transitions.normal};

  // &:hover {
  //   box-shadow: ${theme.shadows.md};
  // }
`

// AccordionHeader
// Full-width clickable button row. Reset all button styles.

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({isOpen}) => (isOpen ? '0 0 10px 0' : '0')};
  background: ${({isOpen}) => (isOpen ? theme.palette.thryv.bg : '#ffffff')};
  border: none;
  cursor: pointer;
  text-align: left;
  gap: ${theme.space[4]};
  font-family: ${theme.fonts.body};
  transition: background-color ${theme.transitions.fast};
  border-bottom: ${({isOpen}) => (isOpen ? '1px solid #e5e7eb' : 'none')};

  &:hover {
    // background-color: ${theme.colors.bg.secondary};
  }

  &:focus-visible {
    outline: none;
    // box-shadow: inset 0 0 0 2px ${theme.colors.input.borderFocus};
  }
`

// AccordionHeaderLeft
// Takes up all available space — holds the badge content.

export const AccordionHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`

// AccordionHeaderRight
// Fixed right side — holds delete button and chevron.

export const AccordionHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  flex-shrink: 0;
`

// ChevronIcon
// Rotates 180° when open. isOpen prop drives the transform.

const chevronOpenStyles = ({isOpen}) =>
  isOpen &&
  css`
    transform: rotate(180deg);
  `

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.muted};
  transform: rotate(0deg);
  transition: transform ${theme.transitions.normal};
  visibility: ${({hideChevron}) => (hideChevron ? 'hidden' : 'visible')};

  ${chevronOpenStyles}
`

// DeleteButton
// Icon-only button. Sits left of the chevron in the header right slot.

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: ${theme.space[1]};
  border-radius: ${theme.radii.sm};
  color: ${theme.colors.text.muted};
  cursor: pointer;
  transition: color ${theme.transitions.fast},
    background-color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.status.danger.icon};
    background-color: ${theme.colors.status.danger.bg};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${theme.colors.status.danger.border};
  }
`

// ─── AccordionBody ────────────────────────────────────────────────────────────
// Content area shown when accordion is open.
// Border-top separates it visually from the header.

export const AccordionBody = styled.div`
  // padding: ${theme.space[4]} ${theme.space[6]} ${theme.space[5]};
  // border-top: 1px solid ${theme.colors.border.light};
  background: ${({isOpen}) => (isOpen ? theme.palette.thryv.bg : '#ffffff')};
`
